<template>
  <div v-if="isOpen" class="modal-overlay" @click.self="close">
    <div class="modal-content">

      <!-- Close -->
      <button class="close-btn" @click="close">×</button>

      <!-- Başlık -->
      <h2 class="spin-title">{{ $t('sidebar.rivospin') }}</h2>

      <!-- Geri Sayım -->
      <p v-if="!canSpin" class="cooldown-text">
         {{ $t('sidebar.Tekrar spin atmana') }}: <span>{{ countdown }}</span>
      </p>

      <!-- Kazanç Popup -->
      <div v-if="showWinPopup" class="win-popup">
       <strong>{{ lastWin.toFixed(2) }}</strong> {{ $t('sidebar.kazandın') }}!
      </div>

      <!-- Wheel -->
      <div class="wrapper">
        <div class="plate" :class="spinClass" ref="plateRef">
          <div class="sector-anchor">
            <div
              v-for="(slice, idx) in slices"
              :key="idx"
              :class="'sector-' + idx"
              class="sector-item"
            >
              <span class="amount">
                {{ formatAmount(slice?.displayAmount) }}

              </span>
              <img class="coin-icon" src="@/assets/img/coins/USDT.svg" />
            </div>
          </div>
        </div>

        <div class="frame"></div>
        <div class="light-1"></div>
        <div class="light-2"></div>

        <button
          id="go-button"
          @click="spin"
          :disabled="isSpinning || !canSpin"
        ></button>
      </div>

   

      <!-- Errors -->
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";

// Props
const props = defineProps({
  isOpen: Boolean,
});

const formatAmount = amount => {
  if (amount === undefined || amount === null || isNaN(amount)) return "0.00";
  return Number(amount).toFixed(2);
};


const emit = defineEmits(["close"]);

// State
const slices = ref([]);
const spinClass = ref("");
const isSpinning = ref(false);
const errorMessage = ref("");
const winners = ref([]);

const canSpin = ref(true);
const countdown = ref("00:00:00");
const spinCooldownHours = ref(24);

// Kazanç popup
const lastWin = ref(0);
const showWinPopup = ref(false);

onMounted(async () => {
  await loadSlices();
  await loadStatus();
  await loadWinners();
  startCountdownTimer();
});

const loadSlices = async () => {
  const res = await axios.get("/bonus/wheel/slices");
  slices.value = res.data.slices;
  document.documentElement.style.setProperty(
    "--slice-count",
    slices.value.length
  );
};

const loadStatus = async () => {
  const res = await axios.get("/bonus/wheel/status");
  canSpin.value = res.data.canSpin;
  spinCooldownHours.value = res.data.cooldownHours;

  if (!res.data.canSpin) {
    updateCountdown(res.data.remainingMs);
  }
};

const loadWinners = async () => {
  const res = await axios.get("/bonus/wheel/winners");
  winners.value = res.data.winners;
};

// Countdown
const updateCountdown = (ms) => {
  let s = Math.floor(ms / 1000);
  const h = String(Math.floor(s / 3600)).padStart(2, "0");
  s %= 3600;
  const m = String(Math.floor(s / 60)).padStart(2, "0");
  const sec = String(s % 60).padStart(2, "0");

  countdown.value = `${h}:${m}:${sec}`;
};

let countdownInterval = null;
const startCountdownTimer = () => {
  countdownInterval = setInterval(async () => {
    const res = await axios.get("/bonus/wheel/status");
    canSpin.value = res.data.canSpin;

    if (res.data.canSpin) {
      countdown.value = "Hazır!";
      return;
    }

    updateCountdown(res.data.remainingMs);
  }, 1000);
};

const close = () => {
  if (!isSpinning.value) emit("close");
};

const spin = async () => {
  if (isSpinning.value || !canSpin.value) return;

  try {
    isSpinning.value = true;
    errorMessage.value = "";

    // 1) Server → sadece sonucu alıyoruz
  const res = await axios.post("/bonus/wheel/spin");

const sliceOrder = res.data.sliceIndex;
const winFiat = res.data.fiatReward;

// 🔥 order → gerçek array index dönüşümü
const index = slices.value.findIndex(
  s => s.order === sliceOrder
);

if (index === -1) {
  throw new Error("Slice not found for order: " + sliceOrder);
}

lastWin.value = winFiat;

 

    // 2) Çark dönmeye başlar
    spinClass.value = `spinning-${index}`;

    // 3) ANİMASYON BİTİNCE KAZANÇ GÖSTER
    setTimeout(() => {
      spinClass.value = `rotate-to-${index}`;

      // Animasyon bitti
      isSpinning.value = false;

      // Popup göster
      showWinPopup.value = true;
      setTimeout(() => (showWinPopup.value = false), 2500);

      // Spin hakkını kapat & cooldown başlat
      canSpin.value = false;

      loadStatus();
      loadWinners();

    }, 5000); // animasyon süresi

  } catch (e) {
    console.log(e);
    isSpinning.value = false;
    errorMessage.value = "Bir hata oluştu, tekrar deneyin.";
  }
};

</script>

<style scoped lang="scss">

:root {
  --slice-count: 10;
}

/* ---------------- MODAL ---------------- */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55); /* Daily’de hafif karartma yok ama modal için daha mantıklı */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 90000;
}

/* ---------------- MODAL İÇERİK KUTUSU ---------------- */

.modal-content {
  background-image: url("@/assets/img/spinbg.gif");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  width: 100%;
  max-width: 520px;
  border-radius: 20px;
  padding: 22px;
  position: relative;

  max-height: 88vh;
  animation: fadeUp .25s ease-out;

  border: 2px solid rgba(255,255,255,0.05);
  box-shadow: 0 0 25px rgba(0,0,0,0.45);
}


/* Fade-up animasyonu */
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ---------------- CLOSE BUTTON ---------------- */

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;

  font-size: 28px;
  color: white;

  background: rgba(0,0,0,0.55);
  backdrop-filter: blur(4px);

  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.15);

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
  z-index: 99999;
  transition: 0.15s ease;
}

.close-btn:hover {
  transform: scale(1.12);
}

.close-btn:hover {
  transform: scale(1.1);
}

/* ---------------- WHEEL ---------------- */

.spin-title {
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 6px;
}

/* cooldown */
.cooldown-text {
  text-align: center;
  color: #ffd86b;
  font-size: 14px;
  margin-bottom: 12px;
}

/* kazanç popup */
.win-popup {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--active-button);
  padding: 10px 20px;
  border-radius: 12px;
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  animation: winPop 0.4s ease;
}
@keyframes winPop {
  0% { transform: translateX(-50%) scale(0.5); opacity: 0; }
  100% { transform: translateX(-50%) scale(1); opacity: 1; }
}

/* sağ alt kazananlar kutusu */
.winners-box {
  position: absolute;
  right: -140px;
  bottom: 20px;
  width: 130px;
  background: rgba(0,0,0,0.45);
  border-radius: 10px;
  padding: 10px;
  backdrop-filter: blur(4px);
}

.winners-box h4 {
  color: #fff;
  font-size: 13px;
  margin-bottom: 6px;
  text-align: center;
}

.winner {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #fff;
  margin-bottom: 4px;
}

.winner-amount {
  color: #00ffae;
}

.wrapper {
  position: relative;
 
  aspect-ratio: 1/1;

  > * {
    position: absolute;
    inset: 0;
    background-size: contain;
    background-repeat: no-repeat;
  }
}

.plate {
  background-image: url("https://i.imgur.com/uDg2aPA.png");

  .sector-anchor {
    position: absolute;
    top: 50%;
    width: 100%;
    aspect-ratio: calc(var(--slice-count) / 2);
    transform: translateY(-50%);

    > * {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: end;
      padding-right: 16%;
      gap: 6px;
    }

    @for $i from 0 through 30 {
      .sector-#{$i} {
        transform: rotate(calc(#{$i} * (-360deg / var(--slice-count))));
      }
    }
  }

  @for $i from 0 through 30 {
    &.spinning-#{$i} {
      transition: transform 5s ease-in-out;
      transform: rotate(calc((360deg / var(--slice-count)) * #{$i} + 360deg * 5));
    }
    &.rotate-to-#{$i} {
      transform: rotate(calc((360deg / var(--slice-count)) * #{$i}));
    }
  }
}

.frame {
  background-image: url("https://i.imgur.com/6hOfWBr.png");
}

.light-1,
.light-2 {
  opacity: 0;
  animation: sparkle 0.6s infinite steps(2, jump-none);
}
.light-1 { background-image: url("https://i.imgur.com/wTyEPB4.png"); }
.light-2 {
  background-image: url("https://i.imgur.com/EZWIuKC.png");
  animation-delay: 0.3s;
}

#go-button {
  all: unset;
  position: absolute;
  top: 51%;
  left: 50%;
  width: 20%;
  aspect-ratio: 88/58;
  background-image: url("https://i.imgur.com/8u1k7lO.png");
  background-size: contain;
  cursor: pointer;
  animation: zoom 1s infinite ease-in-out;
}

.amount {
  color: white;
  font-size: 10px;
  font-weight: bold;
}

.coin-icon {
  width: 26px;
  height: 26px;
  object-fit: contain;
}

.error-message {
  margin-top: 12px;
  text-align: center;
  color: #ff4d4d;
  font-weight: 600;
}

.reward-message {
  margin-top: 12px;
  text-align: center;
  color: #4dff7a;
  font-weight: 700;
  font-size: 18px;
}

@keyframes sparkle {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes zoom {
  0%   { transform: translate(-50%, -50%) scale(1); }
  50%  { transform: translate(-50%, -50%) scale(1.4); }
  100% { transform: translate(-50%, -50%) scale(1); }
}

</style>
